:host {
    display: inline-flex;
    flex-shrink: 0;
    user-select: none;
    white-space: nowrap;
    overflow: visible;
    color: inherit;
    line-height: 1;

    position: relative;
}

::slotted(svg) {
    fill: currentColor;
}

::slotted(*) {
    height: 100%;
    width: 100%;
}

.icon-badge {
    position: absolute;
    bottom: calc(100% - 14px);
    left: calc(100% - 12px);
    z-index: 1;
}

.icon-badge[k_isDot] {
    bottom: calc(100% - 6px);
    left: calc(100% - 6px);
}